"use client";

import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";

interface ModalProps {
	isOpen: boolean;
	onClose: () => void;
	message: string;
	title: string;
}

const ConfrimModal: React.FC<ModalProps> = ({ isOpen, onClose, message, title }) => {
	const [mounted, setMounted] = useState(false);

	useEffect(() => {
		setMounted(true);
		return () => setMounted(false);
	}, []);

	if (!isOpen || !mounted) return null;

	return ReactDOM.createPortal(
		<div
			className="fixed inset-0 bg-black bg-opacity-50 z-[9999]"
			onMouseDown={(e) => {
				if (e.target === e.currentTarget) onClose();
			}}
		>
			<div
				className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg p-4 w-[90%] max-w-sm shadow-lg"
				onMouseDown={(e) => e.stopPropagation()}
			>
				<div className="flex justify-between items-center border-b pb-2 mb-4">
					<h2 className="text-xl font-bold text-black">{title}</h2>
					<button
						onClick={(e) => {
							e.stopPropagation(); // ✗ ボタンで背景処理を阻止
							onClose();
						}}
						className="text-gray-600 hover:text-gray-800 text-xl leading-none cursor-pointer"
					>
						✕
					</button>
				</div>
				<p className="text-sm text-black whitespace-pre-wrap">{message}</p>
			</div>
		</div>,
		document.body
	);
};

export default ConfrimModal;